<div
  class="w-full h-full"
  [ngClass]="baseCssConfig?.borderClass !== 'none' ? baseCssConfig?.borderClass : ''"
  [ngStyle]="carouselStyle"
>
  <div
    emblaCarousel
    [options]="emblaOptions"
    [subscribeToEvents]="subscribeToEvents"
    (emblaChange)="onEmblaChange($event)"
    class="embla-carousel"
  >
    <div class="carousel-container" [ngStyle]="carouselSlidesContainerStyle">
      @for (slide of slides; track $index) {
      <div class="carousel-slide" [ngStyle]="getSlideStyle($index)">
        <ng-container
          [ngTemplateOutlet]="slideTemplate"
          [ngTemplateOutletContext]="{ $implicit: slide, index: $index }"
        ></ng-container>
      </div>
      }
    </div>
  </div>

  <!-- Pagination Indicators -->
  @if (carouselConfig?.showPaginationIndicators) {
  <div class="pagination-container">
    @for (slide of slides; track $index) {
    <span class="carousel-dot" (click)="scrollTo($index)">
      <mat-icon svgIcon="dot" [ngStyle]="getPaginationIndicatorStyle($index)"></mat-icon>
    </span>
    }
  </div>
  }
</div>
